<template>
  <div class="content w-full">
    <TopNavbar />
    <div class="page-content">
      <DynamicVisibility  ref="dynamicVisibility">
        <template #primary>
          <AppOverviewComponent @toggle-visibility="toggleVisibility" />
        </template>

        <template #secondary>
					<NotificationComponent />
        </template>
      </DynamicVisibility>
    </div>
  </div>
</template>

<script>
import TopNavbar from '@/components/user/layout/TopNavbar.vue';
import AppListComponent from '@/components/user/viewComponent/appList/AppListComponent.vue';
import AppOverviewComponent from "@/components/user/viewComponent/app/AppOverviewComponent.vue";
import DynamicVisibility from "@/components/custom/visibility/DynamicVisibility.vue";
import NotificationComponent from '@/components/user/viewComponent/notification/NotificationComponent.vue';

export default {
	name: 'NotificationViewComponent',
	components: {
		TopNavbar,
		AppListComponent,
		AppOverviewComponent,
    NotificationComponent,
		DynamicVisibility,
	},
  methods: {
    toggleVisibility(visible) {
      this.$refs.dynamicVisibility.toggle(visible);
    },
  },
};
</script>